import { JSONOption } from '@/models/master-json.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { HigharcPlan, OptionSet } from 'src/app/models/higharc-plan.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HigharcPlanService {
  http = inject(HttpClient);

  haPlan = signal<HigharcPlan | null>(null);
  optionsSets = signal<OptionSet[]>([]);
jsonOptions = signal<JSONOption[]>([]);
  planLoaded = signal<boolean>(false);

  baseUrl = environment.landmark_API_URL + '/higharc';

  constructor() { }

  setHigharcPlan(plan: HigharcPlan | null) {
    this.haPlan.set(plan);
    if(plan){
      this.setPlanLoaded(true);
      if(plan.optionSets){
        this.filterOptions(plan.optionSets);
      }
    }
  }

  getHigharcPlan(builderId:string,planId:string){
    console.log('builderId:',builderId);
    console.log('planId:',planId);
    this.http.get<HigharcPlan>(`${this.baseUrl}/plan/${builderId}/${planId}`).subscribe((data: HigharcPlan) => {
      this.setHigharcPlan(data);
    });
  }

  setPlanLoaded(loaded: boolean) {
    this.planLoaded.set(loaded);
  }

  filterOptions(optionSets: OptionSet[]) {
    const options = optionSets.map(set => ({
      ...set,
      options: set.options.filter(option => option.selected)
    })).filter(set => set.options.length > 0 && (set.name !== 'Exterior Palette' && set.name !== 'Interior Palette' && set.name !== 'Mirror'));
    this.optionsSets.set(options);
    this.setJSONOptions(options);
    console.log('ha options',options);
  }

  convertOptionSets(): Partial<BinderAssembly>[] {
    const optionSets = this.optionsSets();
    const result =  optionSets.map(set => ({
      ...set,
      options: set.options.filter(option => option.selected)
    })).filter(set => set.options.length > 0 && (set.name !== 'Exterior Palette' && set.name !== 'Interior Palette' && set.name !== 'Mirror')).map(set => ({
      Name: set.name,
      Description: set.options.filter(option => option.selected).map(option => option.name).join(' '),
      Price: set.options.reduce((acc, option) => acc + option.price, 0),
      Quantity: 1,
      Type: 'O',
      CategoryID: 349,
      haId: set.id,
      hidden: set.options.some(option => option.selected && option.default && option.price === 0)
    }));
    console.log('ha assemblies',result);
    return result;
  }

  setJSONOptions(options: OptionSet[]) {
    const jsonOptions = options.map(optionSet => {
      const firstOption = optionSet.options[0];
      let optionDescription: string;
  
      if (firstOption.id === 'true' || firstOption.id === 'false') {
        optionDescription = firstOption.id === 'true' 
          ? optionSet.name 
          : `No ${optionSet.name} Selected`;
      } else {
        optionDescription = `${firstOption.name} - ${firstOption.description ? ': ' + firstOption.description : ''}`;
      }
  
      return {
        optionTitle: optionSet.name,
        optionDescription: optionDescription,
        optionPrice: firstOption.price
      };
    });
  
    this.jsonOptions.set(jsonOptions);
  }
}